import { httpInterceptor } from '../http-interceptor';

/**
 * Centralized RBAC API (/api/access/*). Responses use the standard ResponseDataModel
 * shape: { status, response, message, errorMessage }.
 */
export class AccessService {
  static ENDPOINTS = {
    ME: 'access/me',
    CATALOG: 'access/catalog',
    MODULES: 'access/modules',
    PAGES: 'access/pages',
    ROLES: 'access/roles',
    PREVIEW: 'access/roles/preview',
    AUDIT: 'access/audit',
  };

  static async getMe() {
    const res = await httpInterceptor.get(this.ENDPOINTS.ME);
    return res?.response;
  }

  static async getCatalog() {
    const res = await httpInterceptor.get(this.ENDPOINTS.CATALOG);
    return res?.response;
  }

  static async saveModule(module) {
    const res = module.id
      ? await httpInterceptor.put(`${this.ENDPOINTS.MODULES}/${module.id}`, module)
      : await httpInterceptor.post(this.ENDPOINTS.MODULES, module);
    return res?.response;
  }

  static async savePage(page) {
    const res = page.id
      ? await httpInterceptor.put(`${this.ENDPOINTS.PAGES}/${page.id}`, page)
      : await httpInterceptor.post(this.ENDPOINTS.PAGES, page);
    return res?.response;
  }

  static async savePermission(permission) {
    const base = `${this.ENDPOINTS.PAGES}/${permission.pageId}/permissions`;
    const res = permission.id
      ? await httpInterceptor.put(`${base}/${permission.id}`, permission)
      : await httpInterceptor.post(base, permission);
    return res?.response;
  }

  static async getRoles() {
    const res = await httpInterceptor.get(this.ENDPOINTS.ROLES);
    return res?.response || [];
  }

  static async saveRole(role) {
    const res = role.id
      ? await httpInterceptor.put(`${this.ENDPOINTS.ROLES}/${role.id}`, role)
      : await httpInterceptor.post(this.ENDPOINTS.ROLES, role);
    return res?.response;
  }

  static async getRoleMatrix(roleId) {
    const res = await httpInterceptor.get(`${this.ENDPOINTS.ROLES}/${roleId}/matrix`);
    return res?.response;
  }

  static async saveRoleMatrix(roleId, permissionIds, rowVer) {
    const res = await httpInterceptor.put(`${this.ENDPOINTS.ROLES}/${roleId}/matrix`, { permissionIds, rowVer });
    return res?.response;
  }

  static async getPreview(roleIds) {
    const res = await httpInterceptor.get(this.ENDPOINTS.PREVIEW, { roleIds: roleIds.join(',') });
    return res?.response;
  }

  static async getAudit(filter = {}) {
    const params = Object.fromEntries(
      Object.entries(filter).filter(([, v]) => v !== undefined && v !== null && v !== ''),
    );
    const res = await httpInterceptor.get(this.ENDPOINTS.AUDIT, params);
    return res?.response || [];
  }
}
